import type { StaffUser } from '../types';
import { FIDES_TENANT_ID, HARBOUR_TENANT_ID } from './seedReference';

const HQ_ADDRESS = '480 St Kilda Road, Melbourne VIC 3004';

export const JASON_USER_ID = 'u-jason';

export const USERS: StaffUser[] = [
  {
    id: JASON_USER_ID,
    tenantId: FIDES_TENANT_ID,
    name: 'Jason Lont',
    role: 'ADMIN',
    initials: 'JL',
    title: 'Founder & Head of Funds',
    email: 'jason@fidescapital.com.au',
    phone: '0400 000 000',
    address: HQ_ADDRESS,
  },
  {
    id: 'u-alex',
    tenantId: FIDES_TENANT_ID,
    name: 'Alex Morgan',
    role: 'REGISTRY_OFFICER',
    initials: 'AM',
    title: 'Registry Officer',
    email: 'alex@fides.example',
    phone: '0400 000 001',
    address: HQ_ADDRESS,
  },
  {
    id: 'u-priya',
    tenantId: FIDES_TENANT_ID,
    name: 'Priya Nair',
    role: 'APPROVER',
    initials: 'PN',
    title: 'Finance Manager',
    email: 'priya@fides.example',
    phone: '0400 000 002',
    address: HQ_ADDRESS,
  },
  {
    id: 'u-daniel',
    tenantId: FIDES_TENANT_ID,
    name: 'Daniel Osei',
    role: 'COMPLIANCE',
    initials: 'DO',
    title: 'Compliance Manager',
    email: 'daniel@fides.example',
    phone: '0400 000 003',
    address: HQ_ADDRESS,
  },
  { id: 'u-grace', tenantId: FIDES_TENANT_ID, name: 'Grace Lin', role: 'AUDITOR', initials: 'GL' },
  {
    id: 'u-tom',
    tenantId: HARBOUR_TENANT_ID,
    name: 'Tom Becker',
    role: 'REGISTRY_OFFICER',
    initials: 'TB',
  },
  {
    id: 'u-mia',
    tenantId: HARBOUR_TENANT_ID,
    name: 'Mia Torres',
    role: 'APPROVER',
    initials: 'MT',
  },
];
